import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BreadcrumbsItem from '../BreadcrumbsItem';
import Tile from '../Tile';
import FilterPanel from '../FilterPanel';
import { LAYOUT_LEVELS } from '../../constants';
import { getModuleById, getSectionItems, isNodeVisible } from '../../utils';
import FallbackMessage from '../FallbackMessage';
import { FallbackMsg } from '../FallbackMessage/styles';
import {
  Level2,
  SectionTitle,
  SectionNodes,
  Section,
  Sections,
} from './styles';
import { LayoutContainer } from '../Layout/styles';

class LayoutL2 extends PureComponent {
  static propTypes = {
    solution: PropTypes.object.isRequired,
    moduleID: PropTypes.string.isRequired,
    sectionID: PropTypes.string,
    onSectionChanged: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    menuL3AsSection: PropTypes.bool,
  };

  static defaultProps = {
    sectionID: null,
    menuL3AsSection: false,
  };

  state = {
    activeSectionID: this.props.sectionID,
  };

  static getDerivedStateFromProps(props, state) {
    if (state.activeSectionID !== props.sectionID) {
      return { activeSectionID: props.sectionID };
    }

    return null;
  }

  getSectionsFromModule = (module = {}) => {
    if (module.children) {
      return module.children.filter(section => (
        (this.state.activeSectionID ? section.id === this.state.activeSectionID : true)
        && (!section.meta || (section.meta && !section.meta.lpbDashboardHide))
      ));
    }

    return null;
  };

  getItemsFromSection = getSectionItems;

  handleFilterItemClick = sectionID => () => {
    this.setState({ activeSectionID: sectionID });
    this.props.onSectionChanged(sectionID);
  };

  renderSections(sections) {
    return sections
      .map((section) => {
        const items = this.getItemsFromSection(section);

        return (
          <Section key={section.id}>
            <SectionTitle>
              <a // eslint-disable-line
                id={section.id}
              >
                {section.label}
              </a>
            </SectionTitle>
            <SectionNodes>
              {items?.length
                ? items
                  .map(item => (
                    <Tile
                      key={item.id}
                      node={item}
                      level={item?.children?.length && LAYOUT_LEVELS.item}
                    />
                  ))
                : (
                  <FallbackMsg>{this.props.t('LPBD.noItemsMessage')}</FallbackMsg>
                )}
            </SectionNodes>
          </Section>
        );
      });
  }

  render() {
    const { solution, moduleID } = this.props;
    const module = getModuleById(solution, moduleID);

    const sections = this.getSectionsFromModule(module);
    const areSectionsEmpty = sections?.map(this.getItemsFromSection).every((item) => !item) ?? true;
    const useTilesInsteadOfSections = areSectionsEmpty && this.props.menuL3AsSection;

    return (
      <Level2>
        <BreadcrumbsItem to={solution?.uri || '/dashboard'} weight={100}>
          {solution?.label || ''}
        </BreadcrumbsItem>
        <BreadcrumbsItem to={module?.uri || '/dashboard/level2'} weight={200}>
          {module?.label || ''}
        </BreadcrumbsItem>
        {useTilesInsteadOfSections
          ? (
            <LayoutContainer>
              {sections
                .filter(isNodeVisible)
                .map(child => (
                  <Tile
                    key={child.label}
                    node={child}
                  />
                ))}
            </LayoutContainer>
          ) : (
            <>
              <FilterPanel
                activeSectionID={this.state.activeSectionID}
                onItemClick={this.handleFilterItemClick}
                sections={module && module.children}
              />
              <Sections>
                {sections?.length
                  ? this.renderSections(sections)
                  : <FallbackMessage />}
              </Sections>
            </>
          )}
      </Level2>
    );
  }
}

export default withTranslation()(LayoutL2);
